import styled from "styled-components";
import { Theme } from "theme";

export const SetMatchTimesTableContainer = styled.div<{ even: boolean }>`
  overflow: auto;
  background: ${Theme.trackTimesBackground};
  ${({ even }) =>
    even && `background: ${Theme.trackTimesAltBackground} !important`}
`;

export const SetMatchTrackTable = styled.table`
  padding: 10px 0px;
  border-spacing: 0;
`;

export const SetMatchTrackName = styled.div`
  min-width: 120px;
  max-width: 120px; /* Setting just 'width' didn't seem to work */
  text-align: center;
  padding: 0 5px;
  font-size: 14pt;
  font-weight: 500;
`;

export const TrackTableHeader = styled.th`
  font-weight: 500;
`;

export const TrackTableCell = styled.td`
  text-align: center;
  margin: auto;
  padding: 2px 6px;
  white-space: nowrap;

  @media (max-width: 700px) {
    font-size: 10pt;
    padding: 2px 4px;
  }
`;

export const OrgNameCell = styled(TrackTableCell)`
  font-weight: 500;
`;
